import React from 'react';
import PropTypes from 'prop-types';

import IntersectionObserver from '@components/IntersectionObserver';
import RenderGenericChildren from '@components/RenderGenericChildren';
import Observer from '@utils/browser/intersectionObserver';

const MAX_HEIGHT_UPDATES = 2; // First is default item's height, second is calculated from ref.

class LazyComponent extends React.Component {
  childRef = React.createRef();

  state = {
    visible: false,
    style: { minHeight: this.props.height || this.props.defaultHeight },
  };

  heightUpdated = 0;

  componentDidUpdate(prevProps) {
    const { style } = this.state;
    const { count, isDynamic } = this.props;
    const elementHeight = this.getElementHeight;
    if (
      (this.heightUpdated < MAX_HEIGHT_UPDATES ||
        count !== prevProps.count ||
        isDynamic) &&
      elementHeight &&
      style.minHeight !== elementHeight
    ) {
      this.heightUpdated += 1;
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState(s =>
        s.style.minHeight === elementHeight
          ? null
          : { style: { minHeight: elementHeight } },
      );
      const { onHeightUpdated, id } = this.props;
      if (onHeightUpdated) onHeightUpdated(id, elementHeight);
    }
  }

  get getElementHeight() {
    const { offsetHeight } = this.childRef.current;
    return offsetHeight ? `${offsetHeight}px` : 0;
  }

  intersectionCallback = entry => {
    const visible = Observer.elementIsVisible(entry);
    this.setState({ visible });
  };

  render() {
    const { visible, style } = this.state;
    const { children, thresholdMargin } = this.props;
    return (
      <IntersectionObserver
        callback={this.intersectionCallback}
        style={style}
        thresholdMargin={thresholdMargin}
        onInAndOut
      >
        <div ref={this.childRef}>
          {(visible || !style.minHeight) && (
            <RenderGenericChildren>{children}</RenderGenericChildren>
          )}
        </div>
      </IntersectionObserver>
    );
  }
}

LazyComponent.propTypes = {
  defaultHeight: PropTypes.string,
  height: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  thresholdMargin: PropTypes.string,
  count: PropTypes.number,
  children: PropTypes.func.isRequired,
  onHeightUpdated: PropTypes.func,
  isDynamic: PropTypes.bool,
};

export default LazyComponent;
